const ADD_ERROR = 'ADD_ERROR';
const REMOVE_ERROR = 'REMOVE_ERROR';

const ERROR = {
  SOLICITOR: 'SOLICITOR',
  SOURCE_OF_FUNDS: 'SOURCE_OF_FUNDS',
  DIRECTOR: 'DIRECTOR',
  SHAREHOLDER: 'SHAREHOLDER',
  OCCUPATION: 'OCCUPATION',
  INTENT: 'INTENT',
  PURCHASING_WITH_SOMEONE: 'PURCHASING_WITH_SOMEONE',
  FUNDS_PROVIDING: 'FUNDS_PROVIDING',
};

const events = [ADD_ERROR, REMOVE_ERROR];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);
};

export const ADDITIONAL_DETAILS_EVENTS = {
  ADD_ERROR,
  REMOVE_ERROR,
  ERROR,
  initializeEventListeners,
};
